import { useState } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { ArrowLeft, CheckCircle, Loader2 } from 'lucide-react';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);

    const { error } = await supabase.auth.resetPasswordForEmail(
      email.trim(),
      {
        redirectTo: "http://127.0.0.1:5173/update-password"
      }
    );

    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }

    setSuccess(true);
    setLoading(false);
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-8 px-4">
      <div className="w-full max-w-md">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg p-8">
        <div className="text-center mb-8">
            <Link to="/" className="text-2xl font-bold text-nhs-blue">
              TALIS'ON SERVICES
            </Link>
            <h2 className="mt-4 text-xl font-semibold text-gray-900">
              Reset Your Password 
            </h2>
            
          </div>

        {error && (
          <div className="bg-red-50 p-3 rounded text-red-600 mb-4">
            {error}
          </div>
        )}

        {success ? (
          <div className="bg-green-50 p-4 rounded text-green-600 text-center">
            <CheckCircle className="mx-auto mb-2" />
            Check your email for a reset link.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              required
              placeholder="Enter your registered email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border p-3 rounded"
            />

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-nhs-blue text-white py-3 rounded flex justify-center items-center gap-2 rounded-lg"
            >
              {loading ? (
                <Loader2 className="animate-spin w-4 h-4" />
              ) : (
                'Send Reset Link'
              )}
            </button>
          </form>
        )}

        <div className="mt-6 text-center text-sm">
          <Link to="/login" className="text-nhs-blue">
            <ArrowLeft className="inline w-4 h-4 mr-1" />
            Back to Sign In
          </Link>
        </div>
      </div>
    </div>
  </div>
  );
}